module.exports = { id: "pinterest", url: "/build/app/img/symbols.svg#pinterest", viewBox: "", toString: function() { return this.url; } };